/**
 * Form Validators
 * Reusable validation functions for form inputs
 */

/**
 * Validate if a string contains only numbers (allows empty string)
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid
 */
export const validateEcadCode = (value) => {
  return /^[0-9]*$/.test(value);
};

/**
 * Check if ECAD code is valid and has minimum length
 * @param {string} value - The ECAD code to validate
 * @returns {boolean} - True if valid and has at least 4 digits
 */
export const isValidEcadCode = (value) => {
  return value && /^[0-9]{4,}$/.test(value);
};

